module.exports = __webpack_public_path__ + "img/icon-arrow-right-gray.f658dd9e.svg";